{
  "page": { "title": "รายงานรายได้", "subtitle": "{{count}} ออเดอร์ที่ชำระแล้วในช่วงนี้" },
  "column": {
    "settle_time": "วันที่ชำระ",
    "order_no": "เลขออเดอร์",
    "marketplace": "มาร์เก็ตเพลส",
    "seller_name": "ผู้ขาย",
    "currency": "สกุลเงิน",
    "gross": "ยอดรวม",
    "fees": "ค่าธรรมเนียม",
    "net": "ยอดสุทธิ",
    "packages": "พัสดุ"
  },
  "kpi": {
    "orders": "ออเดอร์",
    "gross": "ยอดรวม",
    "fees": "ค่าธรรมเนียม",
    "net": "ยอดสุทธิ"
  },
  "toolbar": {
    "search_placeholder": "ค้นหาเลขออเดอร์…",
    "date_from": "จาก",
    "date_to": "ถึง",
    "marketplace": "มาร์เก็ตเพลส",
    "all_marketplaces": "ทุกมาร์เก็ตเพลส"
  },
  "state": {
    "empty": "ไม่มีออเดอร์ที่ชำระแล้วในช่วงนี้",
    "error": "ไม่สามารถโหลดรายงานรายได้ได้",
    "none": "—"
  }
}
